<template>
  <v-navigation-drawer v-model="openDrawer" :width="220" app :disable-resize-watcher="true" color="appTheme" class="white--text" dark>
    <v-list dense>
      <v-list-item class="my-n1">
        <v-img class="mr-7" :max-width="25" contain :src="require('@/assets/images/logo.png')"></v-img>
        <v-list-item-title class="white--text"><h3>INVOICE AUDIT</h3></v-list-item-title>
      </v-list-item>
    </v-list>
    <v-divider></v-divider>
    <v-list dense class="mt-n2">
      <v-list-item v-for="(menu, index) in menus" :key="index" router :to="menu.route" color="primary">
        <v-list-item-icon class="white--text">
            <v-icon>{{ menu.icon }}</v-icon>
        </v-list-item-icon>
        <v-list-item-title class="white--text">{{ menu.title }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
export default {
  data: () => ({
    openDrawer: true,
    defaultActive: '',
    menus: [
      {
        title: 'EDI Invoices',
        route: '/edi-invoices',
        icon: 'mdi-table-arrow-up'
      },
      {
        title: 'Quickbooks',
        route: '/quickbooks',
        icon: 'mdi-bookshelf'
      },
      {
        title: 'Extensiv',
        route: '/extensiv',
        icon: 'mdi-warehouse'
      },
      {
        title: 'PDF Parsers',
        route: '/parsers',
        icon: 'mdi-file-pdf'
      },
      {
        title: 'Excel Parsers',
        route: '/excel-parsers',
        icon: 'mdi-microsoft-excel'
      },
      {
        title: 'PDF Merge & Split',
        route: '/pdf-merge-split',
        icon: 'mdi-file-pdf-outline'
      }
    ]
  }),
  created(){
    let activeRoute = this.menus.findIndex(menu => menu.route === `/${this.$route.path.split('/')[1]}`);
    this.defaultActive = `${activeRoute+1}`;
  },
  methods: {
    handleDrawer(){
      this.openDrawer = !this.openDrawer
    }
  }
};
</script>

<style scoped>
.sidebar-logo{
    height: 48px;
    background-color: #222933;
    color: #CCCCCC;
    border-bottom: .5px solid #CCCCCC;
}
.sidebar-img{
    margin: 12.5px 0px;
}
.el-menu{
  border: 0;
  overflow-y: auto;
  overflow-x: hidden;
}

::-webkit-scrollbar {
    width: 6px;
}
 
/* Track */
::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3); 
    -webkit-border-radius: 8px;
    border-radius: 8px;
}
 
/* Handle */
::-webkit-scrollbar-thumb {
    -webkit-border-radius: 8px;
    border-radius: 8px;
    background: #00ADFF; 
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.5); 
}
::-webkit-scrollbar-thumb:window-inactive {
  background: #00ADFF;
}
</style>
